import { call, post } from "@/services/api";

// His article list: each code once, with the kits that use it (and how many), under its group, with
// his catalogue chips (prices only for admins).
export type ArticleRow = {
  reference: string; qty: number; owners: { kit: string; label: string; qty: number }[];
  catalog: null | { myotaku_sku: string | null; supplier: string | null; supplier_sku: string | null; price: string | null; currency: string | null; to_confirm: boolean | null };
};
export type ArticleGroup = { kit: string | null; label: string | null; color: string | null; articles: ArticleRow[] };

export const fetchArticleStocks = (warehouseId: number) => call<{ groups: ArticleGroup[] }>(`/api/v1/article_stocks?warehouse_id=${warehouseId}`);
export const countArticles = (warehouseId: number, lines: { article_reference: string; counted: number }[]) =>
  post(`/api/v1/inventories`, { warehouse_id: warehouseId, lines });
// One of his "Points à vérifier" from a run (Ludovic's task A15, steps 4-5b): what needs a person,
// and the delivery it is about. The screen words it in the reader's language.
export type AllocationPoint = {
  kind: "partial" | "not_ticked" | "still_reserved" | "postponed" | "short";
  event_id: number; contract_id: number | null; warehouse_id: number | null; client: string | null; day: string | null;
  done?: number; total?: number; reason?: "missing" | "unapproved" | "feed"; new_day?: string;
  kit?: string; article?: string; before?: number; qty?: number;
};
export const syncAllocations = () =>
  post<{ qualified: number; created: number; updated: number; released: number; delivered: number; without_content: number[]; unknown: string[]; points: AllocationPoint[] }>(`/api/v1/kit_allocations/sync`);

export type SyncRun = {
  ran_at: string; finished_at: string | null; trigger: "schedule" | "button"; by: string | null;
  outcome: { qualified: number; created: number; updated: number; released: number; delivered: number; points?: AllocationPoint[] } | null;
  error: string | null;
};
// When the allocation check last ran — on its own schedule or from the button — and its next times.
export const fetchAllocationRun = () =>
  call<{ last_run: SyncRun | null; next_runs: string[] }>(`/api/v1/kit_allocations/last_run`);
// His "➕ Ajouter": only the quantity received is typed; the server adds it through the ledger.
export const receiveArticles = (warehouseId: number, lines: { article_reference: string; qty: number }[]) =>
  post<{ received: { article_reference: string; added: number; total: number }[] }>(`/api/v1/article_stocks/receive`, { warehouse_id: warehouseId, lines });

// His article entry: add a quantity (a negative removes), ± one, or correct the total.
export const adjustArticle = (b: { warehouse_id: number; article_reference: string; delta?: number; set?: number; mode?: "plus_minus" }) =>
  post<{ article_reference: string; qty: number }>(`/api/v1/article_stocks/adjust`, b);
